module.exports = function(service) {
	'use strict'
	service.service('offlineError',offlineError);
	offlineError.$inject=['$rootScope','$interval','$window'];
	function offlineError($rootScope,$interval,$window) {
		var offlineErrorInterval;
		return function(cb) {
            if($rootScope.offlineError) return
            $rootScope.offlineError = true;
            offlineErrorInterval = $interval(function() {
                if(window.navigator.onLine) {
                    $interval.cancel(offlineErrorInterval);
                    offlineErrorInterval = null;
                    $rootScope.offlineError = false;
                    if(cb && typeof cb === "function") {
                        cb()
                    } else if(cb=='refresh') {
                        $window.location.reload();
                    }
                }
            },1000);
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/offlineErrorService.js
// module id = 618
// module chunks = 0